import { useRef } from "react";
import { Stack } from "@mui/material";
import { useTranslation } from "next-i18next";
import { useDownloadMutation } from "src/api/client/detail-page-download.api";
import { Typography } from "src/components-mui/base/typography/typography";
import { ToastStatus, useWfToast } from "src/hooks/use-wf-toast";
import { EnumDownloadType } from "src/types/common-enum";

interface IPortfolioDownloadPromptProps {
    wikifolioId: string;
}

export const PortfolioDownloadPrompt = ({ wikifolioId }: IPortfolioDownloadPromptProps) => {
    const { t } = useTranslation("common");

    const toast = useWfToast();
    const toastVisible = useRef(false);
    const downloadMutation = useDownloadMutation();

    const onError = (title: string) => {
        if (!toastVisible.current) {
            toastVisible.current = true;
            toast({ status: ToastStatus.Error, duration: 5000, title: title });
            setTimeout(() => {
                toastVisible.current = false;
            }, 5000);
        }
    };

    const onDownloadClick = async () => {
        try {
            await downloadMutation({
                wikifolioId: wikifolioId ?? "",
                type: EnumDownloadType.Portfolio,
            });
        } catch {
            onError(t("general-error"));
        }
    };

    return (
        <Stack
            direction="row"
            sx={{
                justifyContent: "center",
                alignItems: "center",
                fontSize: "sm",
            }}
        >
            <Typography
                sx={{
                    textAlign: "center",
                    fontSize: "sm",
                    fontWeight: "normal",
                    backgroundColor: "transparent",
                    p: 1,
                    pr: 0.5,
                    mt: 2,
                }}
            >
                {t("portfolio-download-text")}
                <Typography
                    component="a"
                    sx={{
                        textDecoration: "underline",
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: "sm",
                    }}
                    onClick={onDownloadClick}
                >
                    {t("portfolio-download-link-text")}
                </Typography>
                .
            </Typography>
        </Stack>
    );
};
